import { Component, Input, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponentContext, BaseSearch, SearchBaseResponse } from '../../../../modules/tcm-core.module';
import { EnumTraslationKeysEnum } from '../../../../models/enums';
import { FieldHistorySearchRequest, IColumnChangeHistory } from '../../../../models/field-history';
import { TranslationService } from '../../../../services';
import { DateTimeStringPipe } from '../../../../modules/tcm-form/pipes/date-time-string.pipe';
import { CurrencyStringPipe } from '../../../../modules/tcm-form/pipes/currency-string.pipe';
import { ShortDateStringPipe } from '../../../../modules/tcm-form/pipes/short-date-string.pipe';
import { TimeStringPipe } from '../../../../modules/tcm-form/pipes/time-string.pipe';

@Component({
    templateUrl: './field-history-search.component.html',
    styleUrls: ['./field-history-search.component.scss'],
    standalone: false
})
export class FieldHistorySearchComponent extends BaseSearch<FieldHistorySearchRequest, SearchBaseResponse<IColumnChangeHistory>>{

    @Input() titleKey: string;
    @Input() typeOfValue: 'currency' | 'date' | 'datetime' | 'enum' | 'time';
    @Input() enumTranslationKey: EnumTraslationKeysEnum;

    rows: IColumnChangeHistory[];

    private enumTranslations: any;

    constructor(
        componentContext: BaseComponentContext,
        route: ActivatedRoute,
        private translationService: TranslationService,
        private dateTimePipe: DateTimeStringPipe,
        private currencyPipe: CurrencyStringPipe,
        private datePipe: ShortDateStringPipe,
        private timePipe: TimeStringPipe,
    ) {
        super(componentContext, route);
        this.actionName = "EntityFieldHistory";
    }

    override ngAfterViewInit() {

        if (this.typeOfValue == 'enum' && this.enumTranslationKey) {
            this.enumTranslations = this.translationService.getEnumTranslation(this.enumTranslationKey);
        }

        super.ngAfterViewInit();
    }

    protected override onViewModelChanged() {
        super.onViewModelChanged();

        if (this.typeOfValue === 'enum') {
            this.viewModel.records.forEach(x => {
                if (x.value) {
                    x.value = this.enumTranslations[x.value];
                }
                if (x.previousValue) {
                    x.previousValue = this.enumTranslations[x.previousValue];
                }
            });
        }
        else {
            let pipe: PipeTransform;

            switch (this.typeOfValue) {
                case 'currency':
                    pipe = this.currencyPipe;
                    break;
                case 'date':
                    pipe = this.datePipe;
                    break;
                case 'datetime':
                    pipe = this.dateTimePipe;
                    break;
                case 'time':
                    pipe = this.timePipe;
                    break;
            }

            if(pipe){
                this.viewModel.records.forEach(x => {
                    if (x.value) {
                        x.value = pipe.transform(x.value);
                    }
                    if (x.previousValue) {
                        x.previousValue = pipe.transform(x.previousValue);
                    }
                });
            }
        }

        this.rows = this.viewModel.records;
    }
}
